import { useTranslation } from 'react-i18next';
import { Form, Button } from 'react-bootstrap';
import TabNavigation from './TabNavigation';
import ProgressBar from './ProgressBar';
import i18n from "../../i18n";
import './StepForm.css';

interface StepTwoProps {
    step: number;
    phoneNumber: string;
    isLoading: boolean;
    onPhoneChange: (value: string) => void;
    onSubmit: () => void;
    hasError?: boolean;
    errorMessage?: string;
}

const StepTwo = ({ step, phoneNumber, isLoading, onPhoneChange, onSubmit, hasError, errorMessage }: StepTwoProps) => {
    const { t } = useTranslation();

    const isValidPhoneNumber = (phone: string): boolean => {
        return /^0?9\d{8}$/.test(phone);
    };

    if (step !== 2) return null;

    return (
        <div className="content step-form-container">
            {/* Tab Navigation for Mobile */}
            <TabNavigation step={step} />

            {/* Desktop Progress Indicator */}
            <ProgressBar step={step} />

            {/* Main Content */}
            <div className="step-title-container">
                <div className="step-title">
                    {t('primotech.step2.title') || 'Enter Phone Number'}
                </div>
                <p className="step-description">
                    {t('primotech.step2.description') || 'Enter your registered Libyan phone number to receive an OTP'}
                </p>
            </div>

            {/* Form */}
            <Form style={{marginTop: '30px'}}>
                <Form.Group className="mb-4" controlId="formPhoneNumber">
                    <Form.Label className="form-label-custom">
                        {t('primotech.phoneNumber') || 'Phone Number'}
                    </Form.Label>
                    <div className={`form-input-wrapper ${i18n.language === 'ar' ? 'rtl' : ''}`}>
                        <div className="form-input-icon">📞</div>
                        <Form.Control 
                            type="text" 
                            placeholder={t('primotech.enterPhone')}
                            value={phoneNumber}
                            onChange={(e) => {
                                onPhoneChange(e.target.value);
                            }}
                            className={`form-input-phone ${i18n.language === 'ar' ? 'rtl' : ''}`}
                            dir="ltr"
                        />
                    </div>
                    {!hasError && (
                        <Form.Text className="form-hint">
                            💡{t('primotech.phoneHint')} <span dir='ltr'>9XXXXXXXX</span>
                        </Form.Text>
                    )}
                    {hasError && (
                        <Form.Text className="form-text-error">
                            {errorMessage}
                        </Form.Text>
                    )}
                </Form.Group>

                <Button 
                    variant="primary" 
                    type="button" 
                    onClick={onSubmit}
                    disabled={isLoading || !isValidPhoneNumber(phoneNumber)}
                    className={`submit-button ${isValidPhoneNumber(phoneNumber) && !isLoading ? 'submit-button-active' : 'submit-button-disabled'}`}
                >
                    {!isLoading && (
                        <span className="submit-button-text">
                            {t('primotech.sendOtp') || 'Send OTP'} {i18n.language === 'en' ? '→' : '←'}
                        </span>
                    )}
                    {isLoading && (
                        <span className="submit-button-text">
                            <span className="submit-button-loading-icon">⏳</span>
                            {t('primotech.button.wait') || 'Please wait...'}
                        </span>
                    )}
                </Button>
            </Form>

            {/* Security Badge */}
            <div className="security-badge">
                <p className="security-badge-text">
                    🔒 {t('primotech.security') || 'Your information is encrypted and secure'}
                </p>
            </div>        
        </div>
    );
};

export default StepTwo;